import React from 'react';
import Chatbot from '../chatbot/Chatbot';

/**
 * AdminChatbotPreview: Thin wrapper for Chatbot used in admin customization UI.
 * - Passes all customization props to Chatbot.
 * - Sets mode="admin" to allow Chatbot to adjust features/behavior if needed.
 * - Can be extended to disable real messaging or analytics in preview mode.
 */
export default function AdminChatbotPreview(props) {
  return (
    <Chatbot
      {...props}
      mode="admin"
      // You can override/disable props here if needed for admin-only behavior
    />
  );
}
